import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const LanguageSwitcher = ({ isDark = true }) => {
  const { language, toggleLanguage } = useLanguage();

  const getColor = (isActive) => {
    if (isDark) {
      return isActive ? '#ffffff' : 'rgba(255, 255, 255, 0.7)';
    }
    return isActive ? '#2a2a2a' : 'rgba(42, 42, 42, 0.6)';
  };

  const getBorderColor = () => isDark ? '#ffffff' : '#2a2a2a';

  return (
    <div className="language-switcher">
      <button
        className={`lang-btn ${language === 'en' ? 'active' : ''}`}
        onClick={() => toggleLanguage('en')}
        style={{
          color: getColor(language === 'en'),
          borderBottom: language === 'en' ? `1px solid ${getBorderColor()}` : 'none'
        }}
      >
        EN
      </button>
      <span className="lang-separator" style={{ color: isDark ? 'rgba(255, 255, 255, 0.4)' : 'rgba(42, 42, 42, 0.4)' }}>
        /
      </span>
      <button
        className={`lang-btn ${language === 'it' ? 'active' : ''}`}
        onClick={() => toggleLanguage('it')}
        style={{
          color: getColor(language === 'it'),
          borderBottom: language === 'it' ? `1px solid ${getBorderColor()}` : 'none'
        }}
      >
        IT
      </button>
    </div>
  );
};

export default LanguageSwitcher;
